<div class="flex flex-column gap">

    <app-card [title]="'service.settings.general.title'" titleSize="large" class="noMaxHeight">
        <ng-template #content>
            <app-service-widgets-settings #widgetsSettings></app-service-widgets-settings>
        </ng-template>
    </app-card>

    <div class="flex flex-row flex-wrap gap">
        <div class="flex-1">
            <app-card [title]="'service.settings.general.selectColor'" titleSize="large">
                <ng-template #content>
                    <app-color-input [form]="form"></app-color-input>
                </ng-template>
            </app-card>
        </div>

        <div class="flex-3">
            <app-card [title]="'service.settings.general.pohoda.label'" titleSize="large">
                <ng-template #content>
                    <div class="grid-2col gap">
                        <app-text-input [form]="form.controls.pohoda"
                            label="service.settings.general.pohoda.fields.name"
                            id="name"></app-text-input>
                        <app-text-input [form]="form.controls.pohoda"
                            label="service.settings.general.pohoda.fields.pairSymbol"
                            id="pairSymbol"></app-text-input>
                        <app-text-input [form]="form.controls.pohoda"
                            label="service.settings.general.pohoda.fields.prepayment"
                            id="prepayment"></app-text-input>
                        <div></div>
                        <app-text-input [form]="form.controls.pohoda"
                            label="service.settings.general.pohoda.fields.division"
                            id="division"></app-text-input>
                        <app-text-input [form]="form.controls.pohoda"
                            label="service.settings.general.pohoda.fields.center"
                            id="center"></app-text-input>
                    </div>
                </ng-template>
            </app-card>
        </div>
    </div>

    <div class="flex-column gap">
        @if (hasArchiveSettings()) {
            <app-card [title]="'service.settings.general.archive.label'" titleSize="large">
                <ng-template #content>
                    <div class="flex-column gap pt-2">
                        <app-number-input
                            [formField]="archiveSettingsFields.archiveAfterYears"
                            label="service.settings.general.archive.archiveAfterYears"
                            [min]="0"
                            [useGrouping]="false"
                        ></app-number-input>
                        <app-number-input
                            [formField]="archiveSettingsFields.archiveAfterDeathYears"
                            label="service.settings.general.archive.archiveAfterDeathYears"
                            [min]="0"
                            [useGrouping]="false"
                        ></app-number-input>
                        @if (isSocial()) {
                            <app-check-input
                                class="align-self-start"
                                [form]="form.controls.social"
                                label="service.settings.general.social.useWaitingList"
                                id="useWaitingList"
                            ></app-check-input>
                        }
                    </div>
                </ng-template>
            </app-card>
        }
        @if (store.service()?.type === ServiceTypeEnum.HEALTH_CARE) {
            <app-service-workgroup-modal></app-service-workgroup-modal>
            <app-card-table
                [tableTitle]="'service.settings.general.workgroup.label'"
                [columns]="workgroupColumns"
                translatePrefix="service.settings.general.workgroup."
                [hideCheckboxes]="true"
                [additionalFilter]="additionalFilter()"
                [gridData]="$any(store.data.serviceWorkgroups$ | async)"
                [refreshCallback]="store.api.getServiceWorkgroups"
                [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
                (deleteCallbackWithEvent)="deleteWorkgroup($event)"
                (createCallback)="createWorkgroup()"
                (detailCallback)="updateWorkgroup($event)"
            >
            </app-card-table>
        }
    </div>

    @if (form.controls.social.value.useWaitingList) {
        <div>
            <app-service-waiting-list-modal></app-service-waiting-list-modal>
            <app-card-table
                [tableTitle]="'service.settings.general.waitingList.label'"
                [columns]="waitingListColumns"
                translatePrefix="service.settings.general.waitingList."
                [hideCheckboxes]="true"
                [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId.toString()] }]]"
                [gridData]="$any(store.data.serviceWaitingListItems$ | async)"
                [refreshCallback]="store.api.getServiceWaitingListItems"
                [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
                (deleteCallbackWithEvent)="deleteWaitingList($event)"
                (createCallback)="createWaitingList()"
                (detailCallback)="updateWaitingList($event)"
            >
                <ng-template pTemplate="type" let-data="data">
                    {{ 'service.settings.general.waitingList.units.' + data | translate }}
                </ng-template>
            </app-card-table>
        </div>
    }

    <div>
        <app-service-operational-capacity-modal></app-service-operational-capacity-modal>
        <app-card-table
            [tableTitle]="'service.settings.general.operationalCapacity.label'"
            [columns]="operationalCapacityColumns"
            translatePrefix="service.settings.general.operationalCapacity."
            [hideCheckboxes]="true"
            [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId.toString()] }]]"
            [gridData]="$any(store.data.serviceOperationalCapacities$ | async)"
            [refreshCallback]="store.api.getServiceOperationalCapacities"
            [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
            (deleteCallbackWithEvent)="deleteOperationalCapacity($event)"
            (createCallback)="createOperationalCapacity()"
            (detailCallback)="updateOperationalCapacity($event)"
        >
            <ng-template pTemplate="name" let-data="data">
                {{ 'service.settings.general.operationalCapacity.units.' + data | translate }}
            </ng-template>
        </app-card-table>
    </div>

    <ng-template #timeRange let-form>
        <div class="grid-2col_auto gap">
            <app-check-input class="fr-2 ml-3" [form]="form" id="active"
                [label]="'service.settings.general.timeRanges.fields.order.' + form.value.order"
            ></app-check-input>
            <app-date-input [form]="form" [timeOnly]="true" id="from"
                label="service.settings.general.timeRanges.fields.from"
            ></app-date-input>
            <app-date-input [form]="form" [timeOnly]="true" id="to"
                label="service.settings.general.timeRanges.fields.to"
            ></app-date-input>
        </div>
    </ng-template>
    <app-card [title]="timeRangeLabel()" titleSize="large">
        <ng-template #content>
            <div class="flex gap">
                @for (range of form.controls.timeRanges.controls; track $index) {
                    <ng-container>
                        <ng-template [ngTemplateOutlet]="timeRange"
                            [ngTemplateOutletContext]="{ $implicit: range }"></ng-template>
                    </ng-container>
                }
            </div>
        </ng-template>
    </app-card>
</div>

<app-action-buttons class="py-3" (primaryClickEvent)="submit()" secondaryButtonType="return"></app-action-buttons>
